
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/leverage",
      function () {
        return require("private-next-pages/leverage.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/leverage"])
      });
    }
  